<template>
  <div class="dd-wall">
    <header class="dd-wall__hero" :style="heroStyle">
      <div class="dd-wall__hero-inner">
        <div class="dd-wall__branding">
          <img v-if="visuals.logo" class="dd-wall__logo" :src="visuals.logo" alt="logo" />
          <h1 class="dd-wall__title">{{ visuals.name }}</h1>
        </div>
      </div>
       <nav class="dd-wall__tabs dd-wall__tabs--tight">
        <router-link to="/wall/home" exact-active-class="active"><span class="dd-wall__tab-label">{{ $t('wall.tabs.home') }}</span></router-link>
        <router-link v-if="showEffectsTab" :class="{ 'dd-wall__effects-blink': showEffectsLiveAction }" to="/wall/effects" exact-active-class="active"><span class="dd-wall__tab-label">{{ effectsTabLabel }}</span></router-link>
        <router-link to="/wall/about" exact-active-class="active"><span class="dd-wall__tab-label">{{ $t('wall.tabs.about') }}</span></router-link>
        <router-link v-if="showSubscriptionTab" to="/wall/subscription" exact-active-class="active"><span class="dd-wall__tab-label">{{ $t('wall.tabs.subscription') }}</span></router-link>
      </nav>
    </header>
    <div v-if="showStatusBar" class="dd-wall__statusbar">
      <div class="dd-wall__statusbar-inner">
        <span v-if="isLive" class="on-air__status">{{ $t('wall.live.status') }}</span>
        <button v-if="showEffectsLiveAction && $route.name !== 'WallEffects'" class="dd-wall__btn-outline-small" @click="$router.push('/wall/effects')">{{ $t('wall.live.send_effect') }}</button>
        <a v-if="$store.getters.authenticated" href="/logout" class="dd-wall__logout">{{ $t('logout') }}</a>
      </div>
    </div>
    <main class="dd-wall__content">
      <router-view />
    </main>
  </div>
  </template>

<script>
import '@/assets/css/new-design.scss';

export default {
  name: 'WallLayout',
  computed: {
    visuals() { return this.$store.getters.visuals || {}; },
    showStatusBar() { return this.$store.getters.isLive || this.$store.getters.authenticated; },
    isLive() { return this.$store.getters.isLive; },
    donationOnlyMode() { return this.$store.getters.donationOnlyMode; },
    showEffectsTab() {
      return !!this.$store.getters.effectsTabAvailable;
    },
    showEffectsLiveAction() {
      return this.showEffectsTab && this.isLive && !this.donationOnlyMode;
    },
    effectsTabLabel() {
      return this.donationOnlyMode ? this.$t('wall.tabs.one_time_donation') : this.$t('wall.tabs.effects');
    },
    showSubscriptionTab() {
      return !!this.$store.getters.subscriptionsEnabled;
    },
    heroStyle() {
      const bg = this.visuals.coverImage || '';
      return bg ? { backgroundImage: `url(${bg})` } : {};
    },
  },
  methods: {}
}
</script>
